import { render, staticRenderFns } from "./BreadCump.vue?vue&type=template&id=e25ca18c&scoped=true"
import script from "./BreadCump.vue?vue&type=script&lang=js"
export * from "./BreadCump.vue?vue&type=script&lang=js"
import style0 from "./BreadCump.vue?vue&type=style&index=0&id=e25ca18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25ca18c",
  null
  
)

export default component.exports